/**
 * @fileoverview DELETE handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension/actions/:action_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdCacheKeys } from "./constants";
import type {
  DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdProps,
  DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult,
} from "./types";

export const deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionId =
  reactQueryMutationAdapter(
    deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdCacheKeys,
    (
      props: DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdProps
    ): Promise<DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/creative_variants/dimensions/${props.dimension}/actions/${props.actionId}`,
        "DELETE",
        { write_mode: props.write_mode },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  );
